import { Component } from '@angular/core';
import {ICellRendererAngularComp} from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
    selector: 'app-customercellbuttonrenderer',
    templateUrl: './customercellbuttonrenderer.component.html',
    styleUrls: ['./customercellbuttonrenderer.component.scss'],
    standalone: false
})
export class CustomercellbuttonrendererComponent {
  cellValue: string = '';
  params: any = {};
  public displayValue!: string;
  paramStore: any = {};

  hideButton: boolean = false;
  showHideButtonText: boolean = false;
  hideButtonText: string = '';
  buttonText: string = '';
  buttonClass: string = 'btn btn-primary btn-sm';
  buttonIcon: string = '';
  buttonName: string = '';

  

  hideProbationButton: boolean = true;
  showHideProbationButtonText: boolean = true;
  hideProbationButtonText: string = '';
  probationButtonText: string = '';
  probationButtonClass: string = 'btn btn-default btn-sm';
  probationButtonIcon: string = '';
  probationSubmitButtonText: string = '';
  probationResubmitButtonText: string = '';
  probationPendingButtonText: string = '';
  probationUnderReviewButtonText: string = '';
  probationModalTitle: string = '';
  probationButtonName: string = '';
  isIahCustomer: boolean = false;

  buttonClick(params: any) {
      if (this.paramStore!.hasOwnProperty('callback')) {
          this.paramStore.callback(this.paramStore!.data!.authCode, this.paramStore!.data!.driversConsent);
      }
  }

  probationButtonClick(params: any) {
      if (this.paramStore!.hasOwnProperty('probationButtonCallback')) {
            this.paramStore.probationButtonCallback(this.paramStore!.data!.authCode, 
                                                    this.paramStore!.data!.probationStatusId, 
                                                    this.paramStore!.data!.documentId,
                                                    this.paramStore!.data!.firstName,
                                                    this.paramStore!.data!.lastName,
                                                    this.paramStore!.data!.requestDate);

      }
  }

    // gets called whenever the cell refreshes
    refresh(params: ICellRendererParams): boolean {
        this.displayValue = params.value;
        this.paramStore = params;
    
          // Check if properties have been set in params and, if so, assign to control props.
    
          // Probation stuff
          if ('hideProbationButton' in params &&
              typeof params.hideProbationButton === 'function') {
              this.hideProbationButton = params.hideProbationButton(params);
          }
          if ('probationButtonName' in params &&
              typeof params.probationButtonName === 'function') {
              this.probationButtonName = params.probationButtonName(params);
          }
          
          if ('nameProbationButton' in params &&
              typeof params.nameProbationButton === 'function') {
              this.probationButtonText = params.nameProbationButton(params);
          }
          if ('probationSubmitButtonText' in params) {
              this.probationSubmitButtonText = params['probationSubmitButtonText'] as string;
          }
          if ('probationResubmitButtonText' in params) {
              this.probationResubmitButtonText = params['probationResubmitButtonText'] as string;
          }
          if ('probationPendingButtonText' in params) {
              this.probationPendingButtonText = params['probationPendingButtonText'] as string;
          }
          if ('probationUnderReviewButtonText' in params) {
              this.probationUnderReviewButtonText = params['probationUnderReviewButtonText'] as string;
          }
          if ('probationButtonClass' in params) {
              this.probationButtonClass = params['probationButtonClass'] as string;
          }
          if ('probationButtonIcon' in params) {
              this.probationButtonIcon = params['probationButtonIcon'] as string;
          }
          if ('isIahCustomer' in params) {
              this.isIahCustomer = params['isIahCustomer'] as boolean;
          }
    
    
          // Button 1
          if ('buttonText' in  params) {
              this.buttonText = params['buttonText'] as string;
          }
          if ('buttonClass' in  params) {
              this.buttonClass = params['buttonClass'] as string;
          }
          if ('buttonIcon' in params) {
              this.buttonIcon = params['buttonIcon'] as string;
          }
          if ('hideButton' in params &&
              typeof params.hideButton === 'function') {
              this.hideButton = params.hideButton(params!.data!.probationStatusId, params!.data!.requestDate);
          }
          if ('hideButtonText' in params) {
              this.hideButtonText = params['hideButtonText'] as string;
          }
          if ('buttonName' in params &&
              typeof this.params!.buttonName === 'function') {
              this.buttonName = this.params.buttonName(params!.data!.authCode);
          }
      // set value into cell again
      this.paramStore = params;
      this.cellValue = this.getValueToDisplay(params);
      return true;
  }

  getValueToDisplay(params: ICellRendererParams) {
    return params.valueFormatted ? params.valueFormatted : params.value;
  }

  // gets called once before the renderer is used
  agInit(params: ICellRendererParams): void {
    this.displayValue = params.value;
    this.paramStore = params;

      // Check if properties have been set in params and, if so, assign to control props.

      // Probation stuff
      if ('hideProbationButton' in params &&
          typeof params.hideProbationButton === 'function') {
          this.hideProbationButton = params.hideProbationButton(params);
      }
      if ('probationButtonName' in params &&
          typeof params.probationButtonName === 'function') {
          this.probationButtonName = params.probationButtonName(params);
      }
      
      if ('nameProbationButton' in params &&
          typeof params.nameProbationButton === 'function') {
          this.probationButtonText = params.nameProbationButton(params);
      }
      if ('probationSubmitButtonText' in params) {
          this.probationSubmitButtonText = params['probationSubmitButtonText'] as string;
      }
      if ('probationResubmitButtonText' in params) {
          this.probationResubmitButtonText = params['probationResubmitButtonText'] as string;
      }
      if ('probationPendingButtonText' in params) {
          this.probationPendingButtonText = params['probationPendingButtonText'] as string;
      }
      if ('probationUnderReviewButtonText' in params) {
          this.probationUnderReviewButtonText = params['probationUnderReviewButtonText'] as string;
      }
      if ('probationButtonClass' in params) {
          this.probationButtonClass = params['probationButtonClass'] as string;
      }
      if ('probationButtonIcon' in params) {
          this.probationButtonIcon = params['probationButtonIcon'] as string;
      }
      if ('isIahCustomer' in params) {
          this.isIahCustomer = params['isIahCustomer'] as boolean;
      }


      // Button 1
      if ('buttonText' in  params) {
          this.buttonText = params['buttonText'] as string;
      }
      if ('buttonClass' in  params) {
          this.buttonClass = params['buttonClass'] as string;
      }
      if ('buttonIcon' in params) {
          this.buttonIcon = params['buttonIcon'] as string;
      }
      if ('hideButton' in params &&
          typeof params.hideButton === 'function') {
          this.hideButton = params.hideButton(params!.data!.probationStatusId, params!.data!.requestDate);
      }
      if ('hideButtonText' in params) {
          this.hideButtonText = params['hideButtonText'] as string;
      }
      if ('buttonName' in params &&
          typeof this.params!.buttonName === 'function') {
          this.buttonName = this.params.buttonName(params!.data!.authCode);
      }
  }
}
